<div dropdown [autoClose]="true" [insideClick]="true" container="body" #dropdown="bs-dropdown" placement="bottom left">
    <button
        id="button-menu-dividers"
        dropdownToggle
        type="button"
        class="btn btn-primary dropdown-toggle d-flex align-items-center"
        aria-controls="dropdown-menu-dividers"
        [ngClass]="{ 'button-without-caret': !shouldDropdownBeDisplayed }">
        <span id="community-name" class="truncate">{{ communityDisplayName || commonDataService.community }}</span>
        @if (userCommunities.commonNeedAttentionCount) {
            <span class="badge badge-white ms-2">{{ userCommunities.commonNeedAttentionCount | shortNumber }}</span>
        }
        <span class="caret"></span>
    </button>
    @if (shouldDropdownBeDisplayed) {
        <div
            id="dropdown-menu-dividers"
            *dropdownMenu
            class="dropdown-menu"
            role="menu"
            aria-labelledby="button-menu-dividers">
            @if (userCommunities.communities.length > 10) {
                <div class="list-search">
                    <input
                        class="form-control"
                        [(ngModel)]="userCommunitiesKeyword"
                        placeholder="{{ 'Search in communities' | translate }}"
                        type="search" />
                    @if (!filteredCommunitiesCount) {
                        <p class="text-light">{{ 'Communities not found' | translate }}</p>
                    }
                </div>
            }

            <ul class="list-group">
                @for (community of getFilteredCommunities(); track community) {
                    <li class="list-group-item list-group-item-action all-communities-item">
                        <a [href]="community.link">
                            <div class="flex-row d-flex justify-content-between align-items-center">
                                <div class="logo-container">
                                    @if (community.logo) {
                                        <img class="logo" [src]="community.logo" />
                                    }
                                </div>
                                <div>
                                    <div class="community-display-name truncate">
                                        {{ community.communityDisplayName }}
                                    </div>
                                    <div class="community-name truncate">
                                        {{ community.communityName }}
                                    </div>
                                </div>
                                <span class="badge" [ngClass]="{ invisible: community.needAttentionCount === 0 }">{{
                                    community.needAttentionCount | shortNumber
                                }}</span>
                            </div>
                        </a>
                    </li>
                }
            </ul>
        </div>
    }
</div>
